<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string
    description?: string
    icon?: string
  }>(),
  {
    description: undefined,
    icon: undefined,
  },
)
</script>

<template>
  <UCard
    :ui="{
      root: 'divide-y divide-default',
      header: 'p-5 sm:px-6',
      body: 'p-5 sm:p-6',
      footer: 'p-5 sm:px-6',
    }"
  >
    <template #header>
      <div class="flex min-w-0 items-start gap-3">
        <div
          v-if="icon"
          class="bg-primary/10 text-primary ring-primary/20 flex size-9 shrink-0 items-center justify-center rounded-md ring ring-inset"
        >
          <UIcon :name="icon" class="size-5" />
        </div>

        <div class="min-w-0">
          <h2 class="text-highlighted text-base font-semibold">
            {{ title }}
          </h2>
          <p v-if="description" class="text-muted mt-1 text-sm">
            {{ description }}
          </p>
        </div>
      </div>
    </template>

    <slot />

    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </UCard>
</template>
